import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

import {
  cardResponseMock,
  generalTabResponseMock,
  participantsTabResponseMock,
  coursesTabResponseMock,
} from '../lpActivityReport.mock';

const getLPCardData = rest.get(
  `${API_REST_URL}/learning-paths/findOne/:clientId/:lpId`,
  (req, res, ctx) => {
    return res(ctx.delay(1000), ctx.json(cardResponseMock));
  },
);

const getGeneralTabData = rest.get(
  `${API_REST_URL}/learning-paths/statistics/:clientId/:lpId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      // ctx.status(400),
      ctx.json(generalTabResponseMock),
    );
  },
);

const getParticipantsTabData = rest.post(
  `${API_REST_URL}/reports/lp-details/:clientId/:lpId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      // ctx.status(400),
      ctx.json(participantsTabResponseMock),
    );
  },
);

const exportParticipantsTabData = rest.post(
  `${API_REST_URL}/reports/lp-details/export/:clientId/:lpId/:userId`,
  (req, res, ctx) => {
    return res(ctx.delay(2000), ctx.json({}));
  },
);

const getCoursesTabData = rest.get(
  `${API_REST_URL}/learning-paths/sections/:clientId/:lpId`,
  (req, res, ctx) => {
    // coursesTabResponseMock.sectionsCount = 0
    return res(
      ctx.delay(2000),
      // ctx.status(400),
      ctx.json(coursesTabResponseMock),
    );
  },
);

export const lpActivityReportHandlers = [
  getLPCardData,
  getGeneralTabData,
  exportParticipantsTabData,
  getParticipantsTabData,
  getCoursesTabData,
];
